import * as React from 'react'
import type { SVGIllustrationProps } from '../BaseIllustration'
import { BaseIllustration } from '../BaseIllustration'

export const NeighbourIllustration = (props: SVGIllustrationProps) => (
  <BaseIllustration xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 240 160" {...props}>
    <path
      fill="url(#dhl__illustrations_neighbourillustration_svg_a)"
      d="m173.887 119.184 4.481-.83-1.244-.664-4.316.747z"
      opacity={0.6}
    />
    <path
      fill="url(#dhl__illustrations_neighbourillustration_svg_b)"
      d="m121.605 127.732 20.249-3.735-34.108-16.929-20.25 3.734z"
      opacity={0.6}
    />
    <path fill="#C39000" d="M141.854 69.972v54.025l-34.108-16.929V53.043z" />
    <path fill="#FCCE09" d="m171.978 38.852-30.124 31.12v54.025l60.249-10.705V59.018z" />
    <path fill="#99460E" d="m141.356 71.217 30.622-33.527-35.851-17.925-30.622 33.776z" />
    <path fill="#823C0D" d="M141.356 71.217v4.399l-35.851-17.677v-4.398z" />
    <path fill="#BC5F20" d="M141.356 71.217v5.062l30.622-33.776 32.116 22.573v-5.062L171.978 37.69z" />
    <path fill="#BA7A61" d="M178.368 76.28v42.074l19.668-3.485V72.711z" />
    <path fill="#994D0E" d="m178.368 76.28 19.668-3.57-1.327-.746-19.585 3.651z" />
    <path fill="#602C0A" d="M178.368 76.28v42.074l-1.244-.581V75.616z" />
    <path fill="#E2E2E2" d="m196.958 97.11-3.403.663v-.913l3.403-.664z" />
    <path fill="#F7F6E4" d="M149.157 82.587v20.083l20.498-3.652V78.852z" />
    <path fill="#E4F4F4" d="m169.655 80.76-16.93 21.329 8.465-1.494 8.465-8.963z" />
    <path fill="#C6E5E4" d="m169.655 91.632-8.465 8.963 8.465-1.577z" />
    <path fill="#BA7A61" d="M148.41 81.757v21.991l1.41-.249V81.508zM168.908 78.022v22.075l1.493-.249V77.773z" />
    <path fill="#BA7A61" d="M148.41 102.171v1.577l21.991-3.9v-1.66zM148.41 81.757v1.576l21.991-3.9v-1.66z" />
    <path fill="#602C0A" d="M148.41 81.757v21.991l-.913-.415V81.342z" />
    <path fill="#994D0E" d="m148.41 81.757 21.991-3.984-.995-.498-21.909 4.067z" />
    <path
      fill="url(#dhl__illustrations_neighbourillustration_svg_c)"
      d="m38.202 119.516-20.25 3.735 34.109 16.929 20.249-3.734"
      opacity={0.6}
    />
    <path
      fill="url(#dhl__illustrations_neighbourillustration_svg_d)"
      d="m104.343 131.632 4.482-.829-1.245-.664-4.316.747z"
      opacity={0.6}
    />
    <path fill="#C39000" d="M72.31 82.42v54.026l-34.108-16.93V65.491z" />
    <path fill="#FCCE09" d="M102.434 51.3 72.31 82.42v54.026l60.249-10.706V71.466z" />
    <path fill="#99460E" d="m71.812 83.665 30.622-33.527-35.85-17.925L35.96 65.989z" />
    <path fill="#823C0D" d="M71.812 83.665v4.399l-35.85-17.677V65.99z" />
    <path fill="#BC5F20" d="M71.812 83.665v5.063l30.622-33.776 32.117 22.572v-5.062l-32.117-22.324z" />
    <path fill="#BC9361" d="M108.824 88.728v42.075l19.669-3.486V85.159z" />
    <path fill="#996A0D" d="m108.824 88.728 19.669-3.569-1.328-.747-19.585 3.652z" />
    <path fill="#634509" d="M108.824 88.728v42.074l-1.244-.58V88.064z" />
    <path fill="#E2E2E2" d="m127.414 109.557-3.403.664v-.913l3.403-.663z" />
    <path fill="#F7F6E4" d="M79.613 95.035v20.083l20.498-3.652V91.3z" />
    <path fill="#E4F4F4" d="m100.111 93.209-16.93 21.328 8.465-1.494 8.465-8.963z" />
    <path fill="#C6E5E4" d="m100.111 104.08-8.465 8.963 8.465-1.577z" />
    <path fill="#BC9361" d="M78.866 94.205v21.992l1.41-.249V93.956zM99.364 90.47v22.075l1.494-.249V90.221z" />
    <path fill="#BC9361" d="M78.866 114.62v1.576l21.992-3.9v-1.66zM78.866 94.205v1.577l21.992-3.9v-1.66z" />
    <path fill="#634509" d="M78.866 94.205v21.992l-.913-.415V93.79z" />
    <path fill="#996A0D" d="m78.866 94.205 21.992-3.984-.996-.498-21.909 4.067z" />
    <defs>
      <linearGradient
        id="dhl__illustrations_neighbourillustration_svg_a"
        x1={175.019}
        x2={175.316}
        y1={118.672}
        y2={117.762}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.25} stopOpacity={0} />
        <stop offset={0.599} stopOpacity={0.3} />
        <stop offset={1} stopOpacity={0.8} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_neighbourillustration_svg_b"
        x1={109.109}
        x2={114.41}
        y1={120.652}
        y2={109.161}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.25} stopOpacity={0} />
        <stop offset={0.599} stopOpacity={0.3} />
        <stop offset={1} stopOpacity={0.8} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_neighbourillustration_svg_c"
        x1={39.565}
        x2={44.866}
        y1={133.1}
        y2={121.609}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.25} stopOpacity={0} />
        <stop offset={0.599} stopOpacity={0.3} />
        <stop offset={1} stopOpacity={0.8} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_neighbourillustration_svg_d"
        x1={105.475}
        x2={105.772}
        y1={131.121}
        y2={130.21}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.25} stopOpacity={0} />
        <stop offset={0.599} stopOpacity={0.3} />
        <stop offset={1} stopOpacity={0.8} />
      </linearGradient>
    </defs>
  </BaseIllustration>
)
